import React, { useEffect, useRef, useState } from "react";
import { useAuthenticatedApi } from "../../../../../hooks/useApi";
import Select from "../Select";

interface CitySelectorProps {
  country: number | null;
  city: number | null;
  setCountry: React.Dispatch<number | null>;
  setCity: React.Dispatch<number | null>;
  countriesData: any;
}

const CitySelector: React.FC<CitySelectorProps> = ({
  country,
  setCity,
  setCountry,
  city,
  countriesData,
}) => {
  const [countrySelected, setCountrySelected] = useState<boolean>(false);
  const [stateSelected, setStateSelected] = useState<boolean>(false);
  const [currentCity, setCurrentCity] = useState<number | null>();
  const [currentState, setCurrentState] = useState<number | null>();
  const [currentCountry, setCurrentCountry] = useState<number | null>();
  const [states, setStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);

  const lastState = useRef<number | null>();

  const api = useAuthenticatedApi("PROFILE_LOCATIONS");

  useEffect(() => {
    let mounted = true;
    if (city != null && country != null && mounted && api) {
      setCurrentCountry(country);
      setCurrentCity(city);
      api.get("/states/" + country + "/").then((res) => {
        setStates(res.data.states);
        setCountrySelected(true);
        api.get("/cities/" + country + "/").then((res) => {
          if (mounted) {
            setAllCities(res.data.cities);
            const state = res.data.cities.find((c: any) => c.id === city).state;
            setCurrentState(state);
          }
        });
      });
    }
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api]);

  useEffect(() => {
    if (api && currentCountry != null && currentCountry !== country) {
      setCurrentCity(null);
      setCountry(currentCountry);
      setCities([]);
      setCurrentState(null);
      setStateSelected(false);
      setCountrySelected(false);

      api
        .get("/states/" + currentCountry + "/")
        .then((res) => {
          setStates(res.data.states);
          setCountrySelected(true);
        })
        .catch((e) => {
          console.log(e);
        });
      api
        .get("/cities/" + currentCountry + "/")
        .then((res) => {
          setAllCities(res.data.cities);
        })
        .catch((e) => {
          console.log(e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCountry, api]);

  useEffect(() => {
    if (currentState != null && lastState.current !== currentState) {
      setCities(allCities.filter((c: any) => c.state === currentState));
      setStateSelected(true);
      setCurrentCity(null);
      lastState.current = currentState;
    }
  }, [allCities, currentState]);

  useEffect(() => {
    setCity(currentCity || null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCity]);

  return (
    <div className="flex justify-between flex-grow w-full">
      <div className="flex flex-grow mr-1">
        <Select
          value={currentCountry}
          setValue={setCurrentCountry}
          name="country"
          placeholder="Select country"
          options={countriesData.map((c: any) => {
            return {
              id: c.id,
              value: c.name,
            };
          })}
        />
      </div>
      <div className="flex flex-grow mr-1">
        <Select
          value={currentState}
          setValue={setCurrentState}
          name="state"
          placeholder="Select state"
          disabled={!countrySelected}
          options={states.map((c: any) => {
            return {
              id: c.id,
              value: c.name,
            };
          })}
        />
      </div>
      <div className="flex flex-grow">
        <Select
          value={currentCity}
          setValue={setCurrentCity}
          name="city"
          placeholder="Select city"
          disabled={!stateSelected}
          options={cities.map((c: any) => {
            return {
              id: c.id,
              value: c.name,
            };
          })}
        />
      </div>
    </div>
  );
};

export default CitySelector;
